import { environment } from "../../../enviroment";
import { Product, ProductRepository, Variant } from "../domain/Products";

const BASE_URL = `${environment.openBaas}/v1/products`;

export class HttpProductRepository implements ProductRepository {
  async getAll(): Promise<Product[]> {
    const res = await fetch(`${BASE_URL}`, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch products");
    const data = await res.json();
    return data.response;
  }

  async getById(id: string[]): Promise<Product[] | null> {
    const res = await fetch(`${BASE_URL}/${id.join(",")}`, {
      credentials: "include",
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to fetch product");
    const data = await res.json();

    return data.response;
  }

  async getByProvider(providerId: string): Promise<Product[] | null> {
    const res = await fetch(`${BASE_URL}/provider/${providerId}`, {
      credentials: "include",
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to fetch products by provider");
    const data = await res.json();
    return data.response;
  }

  async create(params: {
    product: Partial<Product>;
    variant: Variant;
  }): Promise<boolean> {
    const res = await fetch(`${BASE_URL}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    });

    if (!res.ok) throw new Error("Failed to create product");
    return true;
  }

  async update(
    id: string,
    params: { product: Partial<Product>; variant: Variant }
  ): Promise<boolean | null> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to update product");
    return true;
  }

  async delete(id: string): Promise<boolean> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to delete product");
    return true;
  }

  async addVariant(productId: string, variant: Variant): Promise<boolean> {
    const res = await fetch(`${BASE_URL}/${productId}/variants`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(variant),
    });

    if (!res.ok) throw new Error("Failed to add variant");
    return true;
  }

  async updateVariant(
    productId: string,
    variantId: string,
    variant: Partial<Variant>
  ): Promise<Variant | null> {
    const res = await fetch(`${BASE_URL}/${productId}/variants/${variantId}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(variant),
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to update variant");
    const data = await res.json();
    return data.response;
  }

  async deleteVariant(productId: string, variantId: string): Promise<boolean> {
    const res = await fetch(`${BASE_URL}/${productId}/variants/${variantId}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to delete variant");
    return true;
  }
}
